/* import __COLOCATED_TEMPLATE__ from './string-editor.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();